/**
 * Personal + license + practice info — everything the license-scope page
 * collects about the insured individual. In-memory only; reload resets.
 */
class PersonalStore {
  #listeners = new Set();

  #firstName = "";
  #lastName = "";
  #dob = "";
  #licenseNum = "";
  #npi = "";
  #practiceAddress1 = "";
  #practiceAddress2 = "";
  #practiceCity = "";
  #practiceState = "";
  #practiceZip = "";
  #collab = true;
  #hipaa = true;
  #riskMgmt = false;
  #assocMember = false;
  #assocName = "";
  #employerName = "";

  get firstName() { return this.#firstName; }
  set firstName(v) { this.#firstName = v; this.#notify(); }

  get lastName() { return this.#lastName; }
  set lastName(v) { this.#lastName = v; this.#notify(); }

  get dob() { return this.#dob; }
  set dob(v) { this.#dob = v; this.#notify(); }

  get licenseNum() { return this.#licenseNum; }
  set licenseNum(v) { this.#licenseNum = v; this.#notify(); }

  get npi() { return this.#npi; }
  set npi(v) { this.#npi = v; this.#notify(); }

  get practiceAddress1() { return this.#practiceAddress1; }
  set practiceAddress1(v) { this.#practiceAddress1 = v; this.#notify(); }

  get practiceAddress2() { return this.#practiceAddress2; }
  set practiceAddress2(v) { this.#practiceAddress2 = v; this.#notify(); }

  get practiceCity() { return this.#practiceCity; }
  set practiceCity(v) { this.#practiceCity = v; this.#notify(); }

  get practiceState() { return this.#practiceState; }
  set practiceState(v) { this.#practiceState = v; this.#notify(); }

  get practiceZip() { return this.#practiceZip; }
  set practiceZip(v) { this.#practiceZip = v; this.#notify(); }

  get collab() { return this.#collab; }
  set collab(v) { this.#collab = !!v; this.#notify(); }

  get hipaa() { return this.#hipaa; }
  set hipaa(v) { this.#hipaa = !!v; this.#notify(); }

  get riskMgmt() { return this.#riskMgmt; }
  set riskMgmt(v) { this.#riskMgmt = !!v; this.#notify(); }

  get assocMember() { return this.#assocMember; }
  set assocMember(v) { this.#assocMember = !!v; this.#notify(); }

  get assocName() { return this.#assocName; }
  set assocName(v) { this.#assocName = v; this.#notify(); }

  get employerName() { return this.#employerName; }
  set employerName(v) { this.#employerName = v; this.#notify(); }

  // Status flags for the "save name + location" PUT (license-scope page).
  #nameSaving = false;
  #nameSaveError = null;

  get nameSaving() { return this.#nameSaving; }
  set nameSaving(v) { this.#nameSaving = !!v; this.#notify(); }

  get nameSaveError() { return this.#nameSaveError; }
  set nameSaveError(v) { this.#nameSaveError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#firstName = "";
    this.#lastName = "";
    this.#dob = "";
    this.#licenseNum = "";
    this.#npi = "";
    this.#practiceAddress1 = "";
    this.#practiceAddress2 = "";
    this.#practiceCity = "";
    this.#practiceState = "";
    this.#practiceZip = "";
    this.#collab = true;
    this.#hipaa = true;
    this.#riskMgmt = false;
    this.#assocMember = false;
    this.#assocName = "";
    this.#employerName = "";
    this.#nameSaving = false;
    this.#nameSaveError = null;
    this.#notify();
  }
}

const personalStore = new PersonalStore();
export default personalStore;
